<template>
  <v-card
    class="mx-auto rounded-card card-shadow"
    v-bind="$attrs"
  >
    <v-card-text class="text--primary">
      <figure>
        <v-chart :options="chart"
                 ref="comprasChart"
                 theme="secondary"
                 autoresize/>
      </figure>
    </v-card-text>
  </v-card>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';
import { buildTimeframeChart, sumData, toEchartData } from '@/utils/chart-utils';
import IndicadoresService from './dashboard-service';

export default {
  props: {
    stringFilter: String,
  },
  data() {
    return {
      savings: null,
      chart: null,
      total: 0,
    };
  },
  mixins: [chartMixin],
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getCompras();
    },
  },
  methods: {
    showLoading() {
      this.$refs.comprasChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      if (!this.$refs.comprasChart) {
        return;
      }
      this.$refs.comprasChart.hideLoading();
    },
    buildChart() {
      const savings = buildTimeframeChart(this.savings);
      this.total = sumData(this.savings, 'value');
      return {
        title: {
          text: 'Compras para o período',
        },
        tooltip: {
          formatter: this.tooltipFormatter,
        },
        dataset: {
          source: [
            ['Saving'],
            ...toEchartData(savings, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category', interval: 1, maxInterval: 1, splitNumber: 1,
        },
        yAxis: {
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          left: '15%',
        },
        series: [{
          type: 'bar',
          seriesLayoutBy: 'column',
          realtimeSort: true,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        }],
      };
    },
    getCompras() {
      const filter = this.stringFilter;

      this.showLoading();
      IndicadoresService.getCompras({ filter })
        .then((response) => {
          this.savings = response.data;
          this.chart = this.buildChart();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  mounted() {
    this.getCompras();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
}
</style>
